import React from 'react';
import { CreditDetails, StatusView } from '../common';

export const DefaultView = ({
  issueInfo = null,
  isDisabled = false,
  orderId = null,
  reasonId = null,
  handleCardLink = () => {},
  sendFormData = () => {},
  tryAgain = () => {},
  cartId = null,
  userId = null,
}) => {
  const submitForm = (urlStr, params) => {
    const { submit_button } = issueInfo;
    let data = { ...params };
    let url = urlStr ? urlStr : submit_button.url;

    data['order_id'] = orderId;
    sendFormData(url, reasonId, data);
  };

  if (!issueInfo) return null;

  return (
    <div className='raiseIssueContainer'>
      {issueInfo.texts ? (
        <StatusView response={issueInfo} tryAgain={tryAgain} />
      ) : (
        <div className='raiseIssueContent'>
          <CreditDetails
            creditOptions={issueInfo}
            sendFormData={submitForm}
            orderId={orderId}
            reasonId={reasonId}
            isDisabled={isDisabled}
            handleCardLink={handleCardLink}
            cartId={cartId}
            userId={userId}
          />
        </div>
      )}
    </div>
  );
};
